import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";
import { IMAGEAPI, API } from "../../../BackendConnections";
import { fetchUserNotificationsAction } from "../../../redux/actions/user/userAction";
import HexaImage from "../imgCards/HexaImage";
import UserLayout from "../user/UserLayout";

const formatTimeDifference = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);
  
  if (diffInSeconds < 60) return 'just now';
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) return `${diffInMinutes} minute${diffInMinutes === 1 ? '' : 's'} ago`;
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `${diffInHours} hour${diffInHours === 1 ? '' : 's'} ago`;
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) return `${diffInDays} day${diffInDays === 1 ? '' : 's'} ago`;
  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) return `${diffInMonths} month${diffInMonths === 1 ? '' : 's'} ago`;
  return `${Math.floor(diffInMonths / 12)} year${Math.floor(diffInMonths / 12) === 1 ? '' : 's'} ago`;
};

export const Notifications = (props) => {
  const [isNotfication, setIsNotification] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const [pollingCount, setPollingCount] = useState(0);
  // Reload data every time component mounts or props change
  useEffect(() => {
    const loadData = async () => {
      try {
        await props.fetchUserNotifications();
      } catch (error) {
        console.error("Error loading notifications:", error);
      }
    };

    loadData(); // Initial load

    // Optional: Add polling if you want continuous refresh
    const pollInterval = setInterval(loadData, 15000); // 15 seconds
    
    return () => clearInterval(pollInterval); // Cleanup on unmount
  }, [props.fetchUserNotifications]);

  // Update local state when Redux notifications change
  useEffect(() => {
    if (props.notifications.length > 0) {
      setNotificationData(props.notifications);
    } else {
      setNotificationData([]);
    }
  }, [props.notifications]);

  const handleRemoveNotifications = async (index, notificationId) => {
    try {
      // Optimistic UI update
      const updatedNotifications = [...notificationData];
      updatedNotifications.splice(index, 1);
      setNotificationData(updatedNotifications);

      // API call
      await axios.delete(
        `${API}/api/notifications/notification/${notificationId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
          }
        }
      );

      // Refresh data after deletion
      await props.fetchUserNotifications();
      
    } catch (error) {
      console.error("Delete failed:", error);
      setNotificationData([...notificationData]); // Revert on error
      alert("Failed to delete notification. Please try again.");
    }
  };

  return (
    <UserLayout>
      <div className="right-section">
        {/* ... (keep your existing header JSX) */}
        
        <div className="row" style={{ float: "center" }}>
          <div className="col-md-2"></div>
          <div className="col-sm-8">
            {notificationData.map((row, index) => {
              const isPasswordRelated = ["Forget Password", "Reset Password"].includes(row.status);
              const profileImage = row.profile_pic 
                ? `${IMAGEAPI}/media/${row.profile_pic}`
                : isPasswordRelated 
                  ? "/assets/images/password.png" 
                  : "/assets/images/no-profile.png";

              return (
                <Link to={row.url || ""} key={row.id || index}>
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-2">
                          <HexaImage image={profileImage} />
                        </div>
                        <div className="col-md-10">
                          <button
                            className="remove-block-notifications"
                            onClick={(e) => {
                              e.preventDefault();
                              handleRemoveNotifications(index, row.id);
                            }}
                          >
                            ×
                          </button>
                          <h5 className="card-title">{row.status}</h5>
                          <p className="card-text">{row.message}</p>
                          <p className="notification-time">
                            {formatTimeDifference(row.updated_at)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
          <div className="col-md-2"></div>
        </div>
      </div>
    </UserLayout>
  );
};

const mapStateToProps = (state) => ({
  notifications: state.user.notifications,
});

const mapDispatchToProps = {
  fetchUserNotifications: fetchUserNotificationsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);